import styled from 'styled-components';
import { colors } from '@/styles';

export const OrganizationSidebar = styled.div`
  display: flex;
  flex-direction: column;
  gap: 50px;
`;

export const Links = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  font-size: 14px;
  a {
    padding: 5px 10px;
    border-radius: 5px;
    &.active {
      background-color: ${colors.secondary.lightGray2};
      font-weight: bold;
    }
  }
`;

export const OrganizationInfo = styled.div`
  display: flex;
  gap: 15px;
`;
